import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';

import { authInterceptor } from './core/interceptor/auth.interceptor';
import { errorInterceptor } from './core/interceptor/error.interceptor';
import { routes } from './app.routes';
import { seedHistoryFloor, trapDashboardBack } from './core/navigation/history-floor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3500,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true,
    }),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    // 'computed' puts the browser history back where it was when a guard
    // cancels back/forward (the exam screen blocks both while a test runs).
    provideRouter(routes, withRouterConfig({ canceledNavigationResolution: 'computed' })),
    // Keeps browser "back" from leaving the app (dashboard is the furthest back).
    provideAppInitializer(seedHistoryFloor),
    provideAppInitializer(trapDashboardBack),
  ],
};
